/**
 * TicketTornPaperShell.tsx — Contenedor visual de ticket con bordes rasgados.
 *
 * QUÉ EXPORTA: TicketTornPaperShell
 * QUÉ NO DEBE HACER: Lógica de venta ni datos de negocio.
 */

import type { CSSProperties, ReactNode } from "react";
import {
  TICKET_TORN_CLIP_PATH,
  TICKET_TORN_DEPTH_PX,
  TICKET_TORN_PAPER,
} from "@/features/caja/constants/ticketTornPaper";

interface TicketTornPaperShellProps {
  children: ReactNode;
  className?: string;
  /** Borde rojo sutil (venta anulada). */
  anulada?: boolean;
}

const bodyStyle = {
  clipPath: TICKET_TORN_CLIP_PATH,
  WebkitClipPath: TICKET_TORN_CLIP_PATH,
  backgroundColor: TICKET_TORN_PAPER,
  paddingTop: TICKET_TORN_DEPTH_PX,
  paddingBottom: TICKET_TORN_DEPTH_PX,
  filter: "drop-shadow(0 2px 10px rgba(0, 0, 0, 0.08))",
} as CSSProperties;

/**
 * Un solo bloque blanco recortado con sierra arriba/abajo (sin costura ni línea).
 */
export function TicketTornPaperShell({
  children,
  className = "",
  anulada = false,
}: TicketTornPaperShellProps) {
  return (
    <div
      className={[
        "ticket-torn-paper-shell relative w-full overflow-visible",
        anulada ? "ring-2 ring-red-400 ring-inset" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="ticket-torn-paper-body relative z-[1]" style={bodyStyle}>
        {children}
      </div>
    </div>
  );
}
